<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>训练平板</el-breadcrumb-item>
      <el-breadcrumb-item>每天训练时长</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <el-form :inline="true" :model="keywords" class="demo-form-inline">
       <el-form-item label="">
          <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入用户账号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksearch">查询</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表 -->
      <el-table v-loading="loading" :data="dataList" border stripe>
        <el-table-column prop="Totaltime" label="总时长"></el-table-column>
        <el-table-column prop="Visiontime" label="视力训练时长"></el-table-column>
        <el-table-column prop="Brainstime" label="脑力训练时长"></el-table-column>
        <el-table-column prop="Begingtime" label="起始时间"></el-table-column>
        <el-table-column prop="Endtime" label="结束时间"></el-table-column>
        <el-table-column prop="Statisticsdate" label="统计日期"></el-table-column>
        <el-table-column prop="Username" label="用户名称"></el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pages">
        <el-pagination
        @current-change="handleCurrentPageChange"
        :page-size="10"
        layout="total, prev, pager, next, jumper"
        :total="dataNum"
        :current-page.sync="selectedPageNo">
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyTrainPadDayTongJi',
  data () {
    return {
      loading: false,
      keywords: {
        loginname: ''
      },
      selectedPageNo: 1,
      dataList: [],
      dataNum: 0
    }
  },
  mounted () {
    this.apiGetTrainPadDayTongJiList()
    this.apiGetTrainPadDayTongJiNum()
  },
  methods: {
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetTrainPadDayTongJiList()
      this.apiGetTrainPadDayTongJiNum()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetTrainPadDayTongJiList()
      this.apiGetTrainPadDayTongJiNum()
    },
    apiGetTrainPadDayTongJiNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTrainPadDayTongJiNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataNum = response.data.Num
          }
		  Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetTrainPadDayTongJiList: function () {
      var that = this
      that.loading = true
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetTrainPadDayTongJiList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
          that.loading = false
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
          that.loading = false
        })
    }
  }
}
</script>

<style lang="less" scoped>

</style>
